var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 27,
    viewBox: "0 0 22 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8266 17.6671C5.43245 17.6671 0.825897 18.4296 0.825897 21.4833C0.825897 24.5369 5.40317 25.3267 10.8266 25.3267C16.2207 25.3267 20.8259 24.563 20.8259 21.5105C20.8259 18.4582 16.2499 17.6671 10.8266 17.6671Z",
    fill: "#2C75C5",
    stroke: "#2C75C5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8266 13.3116C14.3665 13.3116 17.2355 10.628 17.2355 7.31849C17.2355 4.00901 14.3665 1.32671 10.8266 1.32671C7.28672 1.32671 4.41628 4.00901 4.41628 7.31849C4.40429 10.6168 7.25478 13.3004 10.7814 13.3116H10.8266Z",
    fill: "#2C75C5",
    stroke: "#2C75C5",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveProfile);
export default __webpack_public_path__ + "static/media/active-profile.c6ca533131027952c0c8f28238bde36f.svg";
export { ForwardRef as ReactComponent };